export const MAX_DRAWER_WIDTH = 300;
export const MIN_DRAWER_WIDTH = 100;
